import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a string to Proper Case (Title Case).
 * Capitalizes the first letter of each word.
 * Preserves fully uppercase tokens like ISO, DIN, SS, ASTM (likely acronyms).
 * Preserves alphanumeric codes like M8x20, 8.8, etc.
 */
export function toProperCase(str) {
  if (!str || typeof str !== 'string') return str;
  return str.replace(/\b\w+/g, (word) => {
    // Preserve fully uppercase words (2+ chars) — likely acronyms: ISO, DIN, SS, ASTM
    if (word.length >= 2 && word === word.toUpperCase() && /[A-Z]/.test(word)) return word;
    // Preserve words with mixed alphanumeric (e.g., M8x20, 8.8)
    if (/\d/.test(word)) return word;
    // Capitalize first letter, lowercase rest
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

/**
 * Fields that should get Proper Case auto-formatting on blur.
 * Organized by page/context.
 */
export const PROPER_CASE_FIELDS = new Set([
  'name', 'description', 'finish', 'contact_person',
  'city', 'state', 'address', 'payment_terms', 'delivery_terms',
  'customer_name', 'customer_contact_person',
]);
